<template>
  <el-dialog
    v-model="dialogVisible"
    title="新建标签"
    width="500px">
    <div class="mt-3">将框选时间段新建一个标签，并将左右两侧标签重新划分。</div>
    <el-form ref="formRef" size="mini" class="mt-4" label-width="auto" :model="formData" :rules="formRules">
      <el-form-item label="标签名称(左侧)" prop="leftLabel">
        <el-input v-model.trim="formData.leftLabel" size="mini" />
      </el-form-item>
      <el-form-item label="标签名称(框选)" prop="label">
        <el-input v-model.trim="formData.label" size="mini" />
      </el-form-item>
      <el-form-item label="标签名称(右侧)" prop="rightLabel">
        <el-input v-model.trim="formData.rightLabel" size="mini" />
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="onEnsure">确认</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  inject: ['rect', 'initAll'],

  data() {
    return {
      dialogVisible: false,
      formData: {
        leftLabel: '',
        label: '',
        rightLabel: '',
      },
      formRules: {
        leftLabel: [
          {required: true, trigger: 'blur'},
        ],
        label: [
          {required: true, trigger: 'blur'},
        ],
        rightLabel: [
          {required: true, trigger: 'blur'},
        ],
      },
    }
  },

  computed: {
    project() {
      return this.$route.query.project
    },

    id_test() {
      return this.$route.query.id_test
    },
  },

  methods: {
    show() {
      this.formData = {
        leftLabel: '',
        label: '',
        rightLabel: '',
      }

      this.dialogVisible = true
    },

    async submit() {
      const {leftLabel, label, rightLabel} = this.formData
      const params = {
        project: this.project,
        id_test: this.id_test,
        start: this.rect.startXValue,
        end: this.rect.endXValue,
        left_label: leftLabel,
        mid_label: label,
        right_label: rightLabel,
      }
      
      await axios.post('performance/label/', params)
      this.dialogVisible = false
      this.initAll()
    },

    async onEnsure() {
      await this.$refs.formRef.validate((valid, fields) => {
        if (valid) {
          this.submit()
        } else {
          console.log('error submit!', fields)
        }
      })
    }
  }
}
</script>